import React, {ChangeEvent, useEffect} from 'react';
import b_ from 'b_';
import useDebounce from 'react-use/lib/useDebounce';

import {SurveysGoal} from 'client/common/types';

import {AudienceTargeting} from 'client/common/utils/audience';
import {unsetError} from 'client/common/utils/errors';


import {useCanEditAudience} from 'client/common/hooks/edit-mode';
import {useSendGoalOnce} from 'client/common/hooks/metrika';
import {useErrors} from 'client/common/hooks/errors';

import {Textinput} from 'client/common/components/lego';
import BlockInput from 'client/common/components/block-input';

import I18N from 'assets/i18n/brandlift-project';

import {SizeProps} from './types';

const i18n = I18N.common.audienceSettings;
const b = b_.with('audience-settings');

const DEBOUNCE_WAIT = 1000; // как часто отправлять запрос

export default function Size(props: SizeProps) {
    const {onChange, handleUpdate, size, errorMsg, disabled} = props;

    const canEdit = useCanEditAudience();
    const sendGoalOnce = useSendGoalOnce();
    const errors = useErrors();

    const error = errors.size ? {
        message: i18n.sizeError
    } : undefined;

    useEffect(() => {
        if (!errorMsg) {
            unsetError('size');
        }
    }, [errorMsg]);

    useDebounce(
        () => {
            void handleUpdate(size);
        },
        DEBOUNCE_WAIT,
        [size]
    );

    const handleSizeChange = (event: ChangeEvent<HTMLInputElement>) => {
        sendGoalOnce(SurveysGoal.SelectAudience);

        const int = parseInt(event.target.value, 10);

        onChange(int);
    };

    return (
        <BlockInput title={i18n.size.inputTitle} error={error}>
            <Textinput
                className={b('size-input', {view: 'tabs'})}
                disabled={!canEdit || disabled}
                hint={errorMsg}
                onBlur={e => {
                    void handleUpdate(Number(e.target.value), true);
                }}
                onChange={handleSizeChange}
                placeholder={String(AudienceTargeting.DEFAULT_AUDIENCE.size)}
                size='m'
                state={errorMsg ? 'error' : undefined}
                type='number'
                value={size.toString()}
                view='dl'
            />
        </BlockInput>
    );
}
